import { render, staticRenderFns } from "./UniPromotionNew.vue?vue&type=template&id=48e4484d&scoped=true"
import script from "./UniPromotionNew.vue?vue&type=script&lang=js"
export * from "./UniPromotionNew.vue?vue&type=script&lang=js"
import style0 from "./UniPromotionNew.vue?vue&type=style&index=0&id=48e4484d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e4484d",
  null
  
)

export default component.exports